import React from 'react';
import Meta from "../components/Meta";
import PageBanner from '../components/PageBanner';
import TestimonialsBox from '../components/TestimonialsBox';

const Testimonials = () => {
    return (
        <>
            <Meta title="Testimonials - THE CUTTING BAR" />
            <PageBanner imageUrl="assets/images/background/2.jpg" heading="Testimonials" />
            <TestimonialsBox />
        </>
    );
}

export default Testimonials;
